module.exports = __webpack_public_path__ + "static/media/soccer.d4a250d1.jpg";